var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login_area_img"},[_vm._v(_vm._s(_vm.$t('Account.正在登录中')))])}
var staticRenderFns = []

export { render, staticRenderFns }